import ServicesRoutes from './services.routes';

const Services = () => {
  return (
    <>
      <ServicesRoutes />
    </>
  );
};

export default Services;
